function SpendingIcon({ color }: { color: string }) {
  return <svg width="20" height="20" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30 2.38281V21.8828C30 22.4828 29.775 23.0078 29.325 23.4578C28.875 23.9078 28.35 24.1328 27.75 24.1328H2.25C1.65 24.1328 1.125 23.9078 0.675 23.4578C0.225 23.0078 0 22.4828 0 21.8828V2.38281C0 1.78281 0.225 1.25781 0.675 0.807812C1.125 0.357812 1.65 0.132812 2.25 0.132812H27.75C28.35 0.132812 28.875 0.357812 29.325 0.807812C29.775 1.25781 30 1.78281 30 2.38281ZM2.25 6.47031H27.75V2.38281H2.25V6.47031ZM2.25 11.3078V21.8828H27.75V11.3078H2.25ZM2.25 21.8828V2.38281V21.8828Z" fill={color} />
  </svg>
  
}

export default SpendingIcon;
